import SectionMap from "./SectionMap";

export default class SectionPvzMap extends SectionMap
{
    constructor()
    {
        super();
    }

    setFields(fields)
    {
        if(isNaN(parseInt(fields['pickup_id']))) {
            throw new Error("pickup id  not found");
        }

        this.price = fields['pickup_price'];
        this.day = fields['pickup_day'];
        this.pickupId = fields['pickup_id'];
        this.address = fields['pickup_address'];
    }

    getHtml()
    {

        let address = `<span>${BX.message("LPOST_DELIVERY_PVZ_NOT_SELECTED")}</span>`;

        if(this.address) {
            address = `${this.address} (${this.pickupId})`;
        }

        return `
            <div class="delivery-info-block">
                <div class="delivery-info-block__row">
                    <div class="delivery-info-block__title">${BX.message("LPOST_DELIVERY_PVZ_TITLE_ADDRESS")}</div>
                    <div class="delivery-info-block__text">${address}</div>
                </div>
                <div class="delivery-info-block__row">
                    <div class="delivery-info-block__title">${BX.message("LPOST_DELIVERY_PVZ_TITLE_DATE_DELIVERY")}</div>
                    <div class="delivery-info-block__text">${this.day}</div>
                </div>
            </div>
            <a href="javascript:void(0);" class="adm-btn lpost-pvz__popup-run">${BX.message("LPOST_DELIVERY_PVZ_TITLE_BUTTON")}</a>
            <div>
                <input type="hidden" name="LPOST_PVZ_ID" value="${this.pickupId}">   
                <input type="hidden" name="LPOST_PVZ_PRICE" value="${this.price}">   
                <input type="hidden" name="LPOST_PVZ_DAY" value="${this.day}">    
                <input type="hidden" name="LPOST_PVZ_ADDRESS" value="${this.address}">    
            </div>
        `;
    }
}


